class CustomerAPIResponseMapper {
  static getUserList(dtoList) {
    return dtoList.map((dto) => dto.user)
  }
}

export { CustomerAPIResponseMapper }
